import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, CircularProgress, InputAdornment, TextField } from '@mui/material';
import axios from 'axios';
import ConfirmDialog from '../components/ConfirmDialog';
import Toast from '../components/Toast';

export default function AdminLoansPage() {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const [search, setSearch] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get('https://api.safenetbanking.com/api/admin/loans', {
      headers: { Authorization: 'Bearer ' + token }
    }).then(res => {
      setLoans(res.data);
      setLoading(false);
    });
  }, []);

  const confirm = (action, id) => {
    setConfirmAction(action);
    setSelectedId(id);
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    const token = localStorage.getItem('token');
    try {
      if (confirmAction === 'approve') {
        await axios.patch(`https://api.safenetbanking.com/api/admin/loans/${selectedId}`, { status: 'approved' }, { headers: { Authorization: 'Bearer ' + token } });
        setLoans(loans.map(l => l.id === selectedId ? { ...l, status: 'approved' } : l));
        setToast({ open: true, message: 'Loan approved', severity: 'success' });
      } else if (confirmAction === 'reject') {
        await axios.patch(`https://api.safenetbanking.com/api/admin/loans/${selectedId}`, { status: 'rejected' }, { headers: { Authorization: 'Bearer ' + token } });
        setLoans(loans.map(l => l.id === selectedId ? { ...l, status: 'rejected' } : l));
        setToast({ open: true, message: 'Loan rejected', severity: 'success' });
      }
    } catch {
      setToast({ open: true, message: 'Action failed', severity: 'error' });
    }
    setConfirmOpen(false);
  };

  return (
    <Box>
      <Typography variant="h5" mb={3}>All Loans</Typography>
      <TextField label="Search Loans" value={search} onChange={e => setSearch(e.target.value)} fullWidth margin="normal" InputProps={{ startAdornment: <InputAdornment position="start">🔍</InputAdornment> }} />
      {loading ? <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}><CircularProgress /></Box> : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>User ID</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loans.filter(l =>
                (l.id?.toString().includes(search) ||
                 l.user_id?.toString().includes(search) ||
                 l.principal?.toString().includes(search) ||
                 l.status?.toLowerCase().includes(search.toLowerCase()) ||
                 l.created_at?.toLowerCase().includes(search.toLowerCase())
                )
              ).map(loan => (
                <TableRow key={loan.id}>
                  <TableCell>{loan.id}</TableCell>
                  <TableCell>{loan.user_id}</TableCell>
                  <TableCell>{loan.principal}</TableCell>
                  <TableCell>{loan.status}</TableCell>
                  <TableCell>{loan.created_at}</TableCell>
                  <TableCell>
                    <Button size="small" variant="outlined" onClick={() => confirm('approve', loan.id)} disabled={loan.status==='approved'}>Approve</Button>
                    <Button size="small" color="error" variant="outlined" sx={{ ml: 1 }} onClick={() => confirm('reject', loan.id)} disabled={loan.status==='rejected'}>Reject</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
      <ConfirmDialog open={confirmOpen} title={confirmAction==='approve' ? 'Approve Loan' : 'Reject Loan'} content={`Are you sure you want to ${confirmAction} this loan?`} onCancel={() => setConfirmOpen(false)} onConfirm={handleConfirm} />
      <Toast open={toast.open} message={toast.message} severity={toast.severity} onClose={() => setToast({ ...toast, open: false })} />
    </Box>
  );
}
